import { render, staticRenderFns } from "./GeneralProperties.vue?vue&type=template&id=0d49bf6c&scoped=true"
import script from "./GeneralProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GeneralProperties.vue?vue&type=style&index=0&id=0d49bf6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49bf6c",
  null
  
)

export default component.exports